function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import SvgCross from "@digital-hig/icon/lib/esm/icons/cross";
export var makeAlertStyles = function makeAlertStyles(_ref) {
  var primitives = _ref.primitives,
    tokens = _ref.tokens;
  return {
    MuiAlert: {
      defaultProps: {
        severity: "info",
        variant: "outlined",
        slots: {
          closeIcon: SvgCross
        }
      },
      styleOverrides: {
        root: _objectSpread(_objectSpread({
          borderRadius: primitives.borderRadii.none,
          color: tokens.colors["ink-on-background"]
        }, tokens.typography["short-copy-small"]), {}, {
          padding: "2px ".concat(primitives.spacings["4"]),
          fontWeight: primitives.fontWeights.stout
        }),
        standard: {
          '& [class*="MuiAlert-action"] > button > svg': {
            color: tokens.colors["ink-on-background"]
          },
          '& [class*="MuiAlert-action"] > button': _objectSpread(_objectSpread({
            backgroundColor: tokens.colors["fade-gradient-transparent"]
          }, tokens.transitions["state-blur"]), {}, {
            "&:hover": _objectSpread({
              backgroundColor: tokens.colors["hover-fill-subtle"]
            }, tokens.transitions["state-activate"]),
            "&:active": _objectSpread({
              backgroundColor: tokens.colors["pressed-fill-subtle"]
            }, tokens.transitions["state-activate"])
          })
        },
        standardInfo: {
          backgroundColor: tokens.colors["fill-engage-slight"],
          '& [class*="MuiAlert-action"] > button': {
            "&:focus-visible": {
              boxShadow: "0px 0px 0px 1px ".concat(primitives.colors.accent.iris, ", 0px 0px 0px 3px ").concat(tokens.colors["fill-primary"])
            }
          }
        },
        standardError: {
          backgroundColor: tokens.colors["fill-alert-slight"],
          '& [class*="MuiAlert-action"] > button': {
            "&:focus-visible": {
              boxShadow: "0px 0px 0px 1px ".concat(primitives.colors.accent.clay, ", 0px 0px 0px 3px ").concat(tokens.colors["fill-primary"])
            }
          }
        },
        standardSuccess: {
          backgroundColor: tokens.colors["fill-success-slight"],
          '& [class*="MuiAlert-action"] > button': {
            "&:focus-visible": {
              boxShadow: "0px 0px 0px 1px ".concat(primitives.colors.accent.plant, ", 0px 0px 0px 3px ").concat(tokens.colors["fill-primary"])
            }
          }
        },
        standardWarning: {
          backgroundColor: tokens.colors["fill-warning-slight"],
          '& [class*="MuiAlert-action"] > button': {
            "&:focus-visible": {
              boxShadow: "0px 0px 0px 1px ".concat(primitives.colors.accent.gold, ", 0px 0px 0px 3px ").concat(tokens.colors["fill-primary"])
            }
          }
        },
        outlined: {
          padding: "1px ".concat(primitives.spacings["4"]),
          '& [class*="MuiAlert-action"] > button > svg': {
            color: tokens.colors["ink-on-background"]
          },
          '& [class*="MuiAlert-action"] > button': _objectSpread(_objectSpread({
            backgroundColor: tokens.colors["fade-gradient-transparent"]
          }, tokens.transitions["state-blur"]), {}, {
            "&:hover": _objectSpread({
              backgroundColor: tokens.colors["hover-fill-subtle"]
            }, tokens.transitions["state-activate"]),
            "&:active": _objectSpread({
              backgroundColor: tokens.colors["pressed-fill-subtle"]
            }, tokens.transitions["state-activate"])
          })
        },
        outlinedInfo: {
          border: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["fill-engage"]),
          backgroundColor: tokens.colors["fill-engage-slight"],
          '& [class*="MuiAlert-action"] > button': {
            "&:focus-visible": {
              boxShadow: "0px 0px 0px 1px ".concat(primitives.colors.accent.iris, ", 0px 0px 0px 3px ").concat(tokens.colors["fill-primary"])
            }
          }
        },
        outlinedError: {
          border: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["fill-alert"]),
          backgroundColor: tokens.colors["fill-alert-slight"],
          '& [class*="MuiAlert-action"] > button': {
            "&:focus-visible": {
              boxShadow: "0px 0px 0px 1px ".concat(primitives.colors.accent.clay, ", 0px 0px 0px 3px ").concat(tokens.colors["fill-primary"])
            }
          }
        },
        outlinedSuccess: {
          border: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["fill-success"]),
          backgroundColor: tokens.colors["fill-success-slight"],
          '& [class*="MuiAlert-action"] > button': {
            "&:focus-visible": {
              boxShadow: "0px 0px 0px 1px ".concat(primitives.colors.accent.plant, ", 0px 0px 0px 3px ").concat(tokens.colors["fill-primary"])
            }
          }
        },
        outlinedWarning: {
          border: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["fill-warning"]),
          backgroundColor: tokens.colors["fill-warning-slight"],
          '& [class*="MuiAlert-action"] > button': {
            "&:focus-visible": {
              boxShadow: "0px 0px 0px 1px ".concat(primitives.colors.accent.gold, ", 0px 0px 0px 3px ").concat(tokens.colors["fill-primary"])
            }
          }
        },
        filled: {
          '[class*="MuiAlert-icon"] svg': {
            color: "inherit"
          }
        },
        filledInfo: {
          backgroundColor: tokens.colors["fill-engage"],
          "& [class*='MuiAlert-icon'], & [class*='MuiAlert-message'], & [class*='MuiAlert-action'] > button > svg, & [class*='MuiLink-root'], && [class*='MuiLink-root']:hover, && [class*='MuiLink-root']:active, && [class*='MuiLink-root']:focus-visible, & [class*='MuiButton-text'], & [class*='MuiButton-outlined'], & [class*='MuiButton-text']:hover, & [class*='MuiButton-outlined']:hover, & [class*='MuiButton-text']:active, & [class*='MuiButton-outlined']:active, & [class*='MuiButton-text']:focus:active, & [class*='MuiButton-outlined']:focus:active, & [class*='MuiButton-text']:focus-visible, & [class*='MuiButton-outlined']:focus-visible": {
            color: tokens.colors["ink-on-fill-engage"]
          },
          "& [class*='MuiLink-root']": {
            cursor: "pointer"
          },
          "& [class*='MuiLink-root'], && [class*='MuiLink-root']:focus-visible": {
            textDecorationColor: tokens.colors["ink-on-fill-engage"]
          },
          "&& [class*='MuiLink-root']:focus-visible, & [class*='MuiButton-text']:focus-visible, & [class*='MuiButton-outlined']:focus-visible": {
            outlineColor: tokens.colors["ink-on-fill-engage"]
          },
          "&& [class*='MuiLink-root']:hover": {
            textDecoration: "none"
          },
          "& [class*='MuiButton-outlined'], & [class*='MuiButton-outlined']:hover, & [class*='MuiButton-outlined']:focus:active, & [class*='MuiButton-outlined']:active, & [class*='MuiButton-outlined']:focus-visible": {
            borderColor: tokens.colors["ink-on-fill-engage"]
          },
          '& [class*="MuiAlert-action"] > button': _objectSpread(_objectSpread({
            backgroundColor: tokens.colors["fade-gradient-transparent"]
          }, tokens.transitions["state-blur"]), {}, {
            "&:hover": _objectSpread({
              backgroundColor: "rgba(255, 255, 255, 0.12)"
            }, tokens.transitions["state-activate"]),
            "&:active": _objectSpread({
              backgroundColor: "rgba(255, 255, 255, 0.16)"
            }, tokens.transitions["state-activate"]),
            "&:focus-visible": {
              boxShadow: "0px 0px 0px 1px ".concat(primitives.colors.accent.iris, ", 0px 0px 0px 3px ").concat(primitives.colors.primary.white)
            }
          })
        },
        filledError: {
          backgroundColor: tokens.colors["fill-alert"],
          "& [class*='MuiAlert-icon'], & [class*='MuiAlert-message'], & [class*='MuiAlert-action'] > button > svg, & [class*='MuiLink-root'], && [class*='MuiLink-root']:hover, && [class*='MuiLink-root']:active, && [class*='MuiLink-root']:focus-visible, & [class*='MuiButton-text'], & [class*='MuiButton-outlined'],  & [class*='MuiButton-text']:hover, & [class*='MuiButton-outlined']:hover, & [class*='MuiButton-text']:active, & [class*='MuiButton-outlined']:active, & [class*='MuiButton-text']:focus:active, & [class*='MuiButton-outlined']:focus:active, & [class*='MuiButton-text']:focus-visible, & [class*='MuiButton-outlined']:focus-visible": {
            color: tokens.colors["ink-on-fill-alert"]
          },
          "& [class*='MuiLink-root']": {
            cursor: "pointer"
          },
          "& [class*='MuiLink-root'], && [class*='MuiLink-root']:focus-visible": {
            textDecorationColor: tokens.colors["ink-on-fill-engage"]
          },
          "&& [class*='MuiLink-root']:focus-visible, & [class*='MuiButton-text']:focus-visible, & [class*='MuiButton-outlined']:focus-visible": {
            outlineColor: tokens.colors["ink-on-fill-engage"]
          },
          "&& [class*='MuiLink-root']:hover": {
            textDecoration: "none"
          },
          "& [class*='MuiButton-outlined'], & [class*='MuiButton-outlined']:hover, & [class*='MuiButton-outlined']:focus:active, & [class*='MuiButton-outlined']:active, & [class*='MuiButton-outlined']:focus-visible": {
            borderColor: tokens.colors["ink-on-fill-alert"]
          },
          '& [class*="MuiAlert-action"] > button': _objectSpread(_objectSpread({
            backgroundColor: tokens.colors["fade-gradient-transparent"]
          }, tokens.transitions["state-blur"]), {}, {
            "&:hover": _objectSpread({
              backgroundColor: "rgba(255, 255, 255, 0.12)"
            }, tokens.transitions["state-activate"]),
            "&:active": _objectSpread({
              backgroundColor: "rgba(255, 255, 255, 0.16)"
            }, tokens.transitions["state-activate"]),
            "&:focus-visible": {
              boxShadow: "0px 0px 0px 1px ".concat(primitives.colors.accent.clay, ", 0px 0px 0px 3px ").concat(primitives.colors.primary.white)
            }
          })
        },
        filledSuccess: {
          backgroundColor: tokens.colors["fill-success"],
          "& [class*='MuiAlert-icon'], & [class*='MuiAlert-message'], & [class*='MuiAlert-action'] > button > svg": {
            color: tokens.colors["ink-on-fill-success"]
          },
          '& [class*="MuiAlert-action"] > button': _objectSpread(_objectSpread({
            backgroundColor: tokens.colors["fade-gradient-transparent"]
          }, tokens.transitions["state-blur"]), {}, {
            "&:hover": _objectSpread({
              backgroundColor: "rgba(0, 0, 0, 0.03)"
            }, tokens.transitions["state-activate"]),
            "&:active": _objectSpread({
              backgroundColor: "rgba(0, 0, 0, 0.15)"
            }, tokens.transitions["state-activate"]),
            "&:focus-visible": {
              boxShadow: "0px 0px 0px 1px ".concat(primitives.colors.accent.plant, ", 0px 0px 0px 3px ").concat(primitives.colors.primary.black)
            }
          })
        },
        filledWarning: {
          backgroundColor: tokens.colors["fill-warning"],
          "& [class*='MuiAlert-icon'], & [class*='MuiAlert-message'], & [class*='MuiAlert-action'] > button > svg": {
            color: tokens.colors["ink-on-fill-warning"]
          },
          '& [class*="MuiAlert-action"] > button': _objectSpread(_objectSpread({
            backgroundColor: tokens.colors["fade-gradient-transparent"]
          }, tokens.transitions["state-blur"]), {}, {
            "&:hover": _objectSpread({
              backgroundColor: "rgba(0, 0, 0, 0.03)"
            }, tokens.transitions["state-activate"]),
            "&:active": _objectSpread({
              backgroundColor: "rgba(0, 0, 0, 0.15)"
            }, tokens.transitions["state-activate"]),
            "&:focus-visible": {
              boxShadow: "0px 0px 0px 1px ".concat(primitives.colors.accent.gold, ", 0px 0px 0px 3px ").concat(primitives.colors.primary.black)
            }
          })
        },
        action: {
          paddingLeft: primitives.spacings["1"],
          "& button svg": {
            height: primitives.spacings["5"],
            width: primitives.spacings["5"]
          }
        },
        message: {
          lineHeight: primitives.lineHeights.compact,
          margin: "10px 0",
          padding: primitives.spacings["0"],
          paddingTop: "1px",
          overflow: "hidden"
        },
        icon: {
          "& svg": {
            height: primitives.spacings["6"],
            width: primitives.spacings["6"]
          }
        }
      }
    },
    MuiAlertTitle: {
      styleOverrides: {
        root: _objectSpread(_objectSpread({
          color: "inherit"
        }, tokens.typography["headline-smaller"]), {}, {
          marginBottom: primitives.spacings["1"],
          lineHeight: primitives.lineHeights.compact
        })
      }
    }
  };
};